import { uiStore } from 'shared/store/uiStore'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const handleDuplicate = (type: ChatbotInstructionType | null, id: number) => {
  let createPath: string

  switch (type) {
    case ChatbotInstructionType.BookAppointment:
      createPath = `/${ChatbotPath.newBookAppointment}`
      break
    case ChatbotInstructionType.Unified:
      createPath = ChatbotPath.newConfig
      break
    default:
      createPath = `/${ChatbotRoutes.root}/${ChatbotRoutes.new}`
  }

  uiStore.changeRoute({
    path: createPath,
    options: {
      state: {
        duplicateId: id,
      },
    },
  })
}
